import { REGIAO_PADRAO, regioesDisponiveis } from "../components/TrilhaLudica";

const normalizar = texto =>
  String(texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const MINHAS_TRILHAS_PATH = "/activity/list?trail=true";

export const MINHAS_TRILHAS_CREATE_PATH = "/activity/create?trail=true";

// Nomes de breadcrumb no lugar dos cadastrados nas rotas ("... de Atividades")
export const TRILHA_BREADCRUMB_LISTAGEM = "Listagem de Trilhas";
export const TRILHA_BREADCRUMB_CADASTRO = "Cadastro de Trilhas";

// Piso de objetos (= fases) de uma trilha. Com 1 passo a regra de recompensas
// faz da PRIMEIRA fase o nó de finalização — o aluno abre a trilha e o único nó
// já é o medalhão do fim, sem percurso nenhum. Uma trilha precisa de um caminho
// para ser uma trilha.
export const TRILHA_MIN_OBJETOS = 2;

// NÃO existe teto de objetos numa trilha, e isso é decisão de produto tomada em
// 31/07/2026: a trilha cresce com o que o professor montou.
//
// Houve um teto de 10, justificado pelos dois limites da arte — a tabela de
// colunas do tabuleiro tinha 10 entradas calibradas, e a imagem de fundo cobria
// pouco mais de 10 nós. Os dois foram resolvidos no módulo em vez de virarem
// regra de negócio: as colunas passaram a ciclar a tabela calibrada, e o cenário
// passou a ser montado em partes empilhadas (ver `partesDoCenario` e o CSS de
// `.trilha-ludica__cenario`). Se um dia voltar a fazer sentido limitar, o lugar é
// aqui — e o motivo terá de ser pedagógico, porque o tabuleiro aguenta N.
/**
 * A trilha tem passos suficientes para ser salva?
 *
 * Vive aqui, e não dentro do ActivityCreator, porque o componente tem 2600 linhas
 * e nenhuma suíte — a regra é o que dá para testar sem montá-lo.
 */
export const temPassosSuficientes = quantidade =>
  Number(quantidade) >= TRILHA_MIN_OBJETOS;

// ---------- Região da trilha ----------
//
// A regra vive aqui, e não dentro do `ActivityCreator`, pelo mesmo motivo de
// `temPassosSuficientes`: aquele componente tem 2600 linhas e nenhuma suíte, então
// o que dá para testar é o que sai dele. Ele fica com os fios; as decisões (quais
// regiões, qual a padrão, quando o campo obedece) ficam aqui.
//
// O CATÁLOGO em si não mora aqui: ele é do módulo da trilha
// (`components/TrilhaLudica`), que é quem sabe o que uma região É. Acrescentar
// região continua sendo encher uma pasta lá — este arquivo não muda.

/**
 * As opções do `<Select>` de região, no formato do react-select.
 *
 * O rótulo junta região e bioma ("Norte — Amazônia") porque é assim que o
 * professor pensa a escolha: ele quer a trilha da Amazônia, e `norte` é a chave
 * que o sistema usa para isso.
 */
export const opcoesDeRegiao = () =>
  regioesDisponiveis().map(({ id, nome, bioma }) => ({
    value: id,
    label: `${nome} — ${bioma}`
  }));

/** A opção correspondente a um id, para o `<Select>` mostrar o valor atual. */
export const opcaoDeRegiao = id =>
  opcoesDeRegiao().find(opcao => opcao.value === id) || null;

// A região que uma trilha nova nasce com. É a mesma que o backend devolve para
// atividade sem registro (`LudicTrailSetting::REGIAO_PADRAO`) — as duas pontas
// precisam concordar, senão a trilha criada antes deste campo existir mostraria uma
// região no servidor e outra na tela.
export const TRILHA_REGIAO_PADRAO = REGIAO_PADRAO.id;

// A REGIÃO NÃO MUDA DEPOIS DA CRIAÇÃO (decisão do Kilson em 05/08/2026), e quem
// impede de verdade é o banco: `LudicTrailSetting::store` usa `firstOrCreate`.
// Aqui é só a tela dizendo isso antes, porque campo que não obedece sem explicar é
// pior que campo ausente.
//
// O motivo é o aluno: a experiência dele guarda os ids das cartas sorteadas
// (`nordeste-problema-03`), e numa região nova esses ids não existem — a fase
// premiada deixaria de entregar carta, sem erro nem log.
export const TRILHA_REGIAO_TRAVADA_AVISO =
  "A região é escolhida na criação e não muda depois: os alunos que já começaram " +
  "guardam as cartas sorteadas dela. Para outra região, crie uma trilha nova.";

// Objetos que não podem ser inseridos em uma atividade de trilha.
//
// "Biblioteca Virtual" e "Bandeiras" entraram em 06/08/2026, a pedido do Kilson.
// Os nomes são os do backend (`content_types.name`, em
// `database/seeds/contentTypesSeeder.php`) — a comparação é por nome
// normalizado, então acento e caixa não importam, mas o nome sim.
const TRILHA_TIPOS_OCULTOS = [
  "Literarte",
  "Editor",
  "Mapa",
  "Simulador",
  "Modelo 3D",
  "Biblioteca Virtual",
  "Bandeiras"
];

export const isTrailQueryActive = search => {
  try {
    return new URLSearchParams(search || "").get("trail") === "true";
  } catch (error) {
    return false;
  }
};

export const isTipoOcultoNaTrilha = nome =>
  TRILHA_TIPOS_OCULTOS.some(tipo => normalizar(tipo) === normalizar(nome));
